import React, { useState } from 'react'
import { Create } from 'react-admin'
import { Box, Typography } from '@mui/material'
import TermsAndConditionsModal from './TermsAndConditionsModal'
import Logo from '@/icons/logo.svg?react'
import SignUpForm from './SignUpForm'
import useAffiliates from '../hooks/useAffiliates'

const AffiliateCreate = () => {
  const { signUp } = useAffiliates()

  const [openTermsModal, setOpenTermsModal] = useState(false)

  const handleOpenTermsModal = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault()
    setOpenTermsModal(true)
  }

  return (
    <Box>
      <Create
        disableAuthentication
        sx={{
          maxWidth: 900,
          height: '100vh',
          margin: 'auto',
          alignContent: 'center',
          padding: '0 20px'
        }}
        component={Box}
        actions={<></>}
      >
        <Logo
          style={{
            width: '200px',
            position: 'absolute',
            top: '20'
          }}
        />
        <Typography
          variant="h3"
          fontSize={24}
          maxWidth="70%"
          textAlign="center"
          justifySelf="center"
          mb={3}
          lineHeight={1.5}
        >
          Create your StackSocial affiliate account below and start promoting
          immediately!
        </Typography>
        <SignUpForm onSubmit={signUp} onTermsClick={handleOpenTermsModal} />
      </Create>
      <TermsAndConditionsModal
        open={openTermsModal}
        onClose={() => setOpenTermsModal(false)}
      />
    </Box>
  )
}

export default AffiliateCreate
